export const UPCOMING_BOOKINGS = [
    {
        id: "b1",
        mentorName: "Dr. Ananya Reddy",
        initials: "DA",
        course: "Additive Manufacturing",
        institution: "IIT Tirupati",
        date: "2026-07-28",
        time: "6:00 PM - 7:00 PM",
        price: 1500,
        status: "upcoming",
        location: "Online",
        mailid: "ananya.reddy@iittp.ac.in",
        mobile: "+91 98765 43210",
    },
    {
        id: "b2",
        mentorName: "Prof. Karthik Iyer",
        initials: "PK",
        course: "Robotics & Mechatronics",
        institution: "IIIT Sri City",
        date: "2026-07-30",
        time: "5:30 PM - 6:15 PM",
        price: 1800,
        status: "upcoming",
        location: "Online",
        mailid: "karthik.iyer@iiits.in",
        mobile: "+91 98450 12345",
    },
    {
        id: "b3",
        mentorName: "Rahul Varma",
        initials: "RV",
        course: "EV Powertrain",
        institution: "Ashok Leyland R&D",
        date: "2026-08-02",
        time: "4:00 PM - 5:00 PM",
        price: 2200,
        status: "confirmed",
        location: "Online",
        mailid: "rahul.varma@ashokleyland.com",
        mobile: "+91 97890 11223",
    },
];

export const ORDER_HISTORY = [
    {
        id: "h1",
        mentorName: "Meera Sundaram",
        initials: "MS",
        course: "PCB & Embedded Design",
        institution: "APIC Visakhapatnam",
        date: "2026-06-14",
        time: "10:00 AM - 10:45 AM",
        price: 1200,
        status: "completed",
        myRating: 5,
        mailid: "meera.sundaram@apic.in",
        mobile: "+91 99887 65432",
    },
    {
        id: "h2",
        mentorName: "Dr. Ananya Reddy",
        initials: "DA",
        course: "Additive Manufacturing",
        institution: "IIT Tirupati",
        date: "2026-05-20",
        time: "6:00 PM - 7:00 PM",
        price: 1500,
        status: "completed",
        myRating: 4,
        mailid: "ananya.reddy@iittp.ac.in",
        mobile: "+91 98765 43210",
    },
    {
        id: "h3",
        mentorName: "Prof. Karthik Iyer",
        initials: "PK",
        course: "Robotics & Mechatronics",
        institution: "IIIT Sri City",
        date: "2026-05-02",
        time: "5:30 PM - 6:15 PM",
        price: 1800,
        status: "cancelled",
        myRating: null,
        mailid: "karthik.iyer@iiits.in",
        mobile: "+91 98450 12345",
    },
];

export function formatDate(iso) {
    return new Date(iso + "T00:00:00").toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
}